import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";

/**
 * Confirmation for an action whose consequence is not obvious from the control that starts
 * it — a package move that changes who sees guest contact, say. `title` asks the question,
 * `children` says what happens, and `confirmLabel` restates the action rather than "OK",
 * so the dialog reads the same whether it is skimmed or read.
 */
export default function ConfirmDialog({ open, title, confirmLabel = "Confirm", onCancel, onConfirm, children }) {
    const colors = tokens(useTheme().palette.mode);
    const panel = { backgroundColor: colors.primary[400] };

    return (
        <Dialog open={Boolean(open)} onClose={onCancel}>
            <DialogTitle sx={{ ...panel, color: colors.grey[100] }}>{title}</DialogTitle>
            <DialogContent sx={panel}>
                <Typography color={colors.grey[200]} fontSize={14} mb={1.5} mt={1} component="div">
                    {children}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ ...panel, px: 3, pb: 2 }}>
                <Button onClick={onCancel} sx={{ textTransform: "none", color: colors.grey[300] }}>
                    Cancel
                </Button>
                <Button onClick={onConfirm} variant="contained" color="secondary" sx={{ textTransform: "none" }}>
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
